import {
  Alert,
  Button,
  Form,
  Input,
  message,
  Spin,
  Typography,
} from "antd";
import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuthContext } from "../../context/AuthContext";
import { API } from "../../constant";
import { setToken } from "../../helpers";

const SignUp = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const refURL = searchParams.get('ref');
  const { setUser } = useAuthContext();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  const onFinish = async (values) => {
    setIsLoading(true);
    try {
      const response = await fetch(`${API}/register`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(values),
      });

      const data = await response.json();
      if (data?.error) {
        throw data?.error;
      } else {
        // set the token
        setToken(data.jwt);
        // set the user
        setUser(data.user);
        message.success(`Welcome to Rankcave Ecommerce ${data.user.full_name}!`);
        refURL ? navigate("/" + refURL, { replace: true }) : navigate("/profile", { replace: true });
      }
    } catch (error) {
      console.error(error);
      setError(error?.message ?? "Something went wrong!");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="container py-5">
      <div className="row py-5">
        <div className="col-md-9 m-auto">
          <div className="card mb-4 product-wap rounded-0">
            <div className="card rounded-0">
              <div className="p-3 mb-2 bg-secondary text-white">Sign Up</div>
              {error ? (
                <Alert
                  className="alert_error"
                  message={error}
                  type="error"
                  closable
                  afterClose={() => setError("")}
                />
              ) : null}
              <Form
                className="card-body"
                name="basic"
                layout="vertical"
                onFinish={onFinish}
                autoComplete="off"
              >
                <Form.Item
                  label="Username"
                  name="username"
                  rules={[
                    {
                      required: true,
                      type: "string",
                    },
                  ]}
                >
                  <Input placeholder="Username" />
                </Form.Item>
                <Form.Item
                  label="Email"
                  name="email"
                  rules={[
                    {
                      required: true,
                      type: "email",
                    },
                  ]}
                >
                  <Input placeholder="Email address" />
                </Form.Item>

                <Form.Item
                  label="Password"
                  name="password"
                  rules={[{ required: true }]}
                >
                  <Input.Password placeholder="Password" />
                </Form.Item>

                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    className="login_submit_btn"
                  >
                    Submit {isLoading && <Spin size="small" />}
                  </Button>
                </Form.Item>
              </Form>
              <Typography.Paragraph className="p-3">
                Already have an account? <Link to={refURL ? "/signin?ref=" + refURL : "/signin" }>Sign In</Link>
              </Typography.Paragraph>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignUp;